import { useContext } from 'react';
import {
	MarketStateParityForPeriodContext,
} from '@app/site/secured/rateshopper/rates/dashboard/fragment/__market-state/common/provider/MarketStateParityForPeriodProvider';


export const useMarketStateParityForPeriod = () => useContext(MarketStateParityForPeriodContext)!;